import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as commonActions from '../../../../app/common/common.action';
import * as actions from './recebimento.action';
import WebapiCommon from '../../../../app/common/util/webapi.common';
import ConfigRecebimentoPage from './recebimento.page';
import ConfiguracaoApi from '../../configuracao.api';
import IntlMessage from '../../../../../src/helpers/intlMessage';

class ConfigRecebimentoContainer extends Component {
  constructor() {
    super();
    this.state = {
      teveAlteracao: false,
      configs: [],
      exe_padrao: null,
    };
  }

  componentDidMount() {
    const requests = [ConfiguracaoApi.getConfiguracaoRecebimentoMaterial()];
    if (this.props.medicos && this.props.medicos.length === 0) {
      const medicos = WebapiCommon.getMedicos();
      requests.push(medicos);
    }

    Promise.all(requests).then((result) => {
      let medicoExecutante = null;
      if (this.props.medicos && this.props.medicos.length === 0) {
        medicoExecutante = result[1].find(
          (medico) => medico.value === result[0].medicoExecutantePadrao
        );
      }

      this.props.commonActions.preencherMedicos(result[1]);
      this.props.commonActions.setMedicoPadraoFaturamento(
        result[0].faturarMedicoPadrao,
        result[0].medicoExecutantePadrao
      );

      let exe_padrao = result[0].medicoExecutantePadrao;

      if (medicoExecutante) {
        this.props.actions.alterarMedicoExecutante(medicoExecutante);
        exe_padrao = medicoExecutante.value;
      } else if (this.props.medicoExecutante) {
        exe_padrao = this.props.medicoExecutante.value;
      }

      this.setState({
        configs: [
          {
            id: 1,
            nome: <IntlMessage id = "dashboards.general.onCheckList"/>,
            valor: result[0].checklistRecebimento,
            key: 'sn_checklist_recebimento',
          },
          {
            id: 2,
            nome: <IntlMessage id = "dashboards.general.printLabel"/>,
            valor: result[0].imprimeEtiquetaControle,
            key: 'sn_imprimecontrole',
          },
          {
            id: 3,
            nome:<IntlMessage id = "dashboards.general.pickupScreen"/>,
            valor: result[0].abreTelaRastreabilidade,
            key: 'sn_recolhimento_manual',
          },
          {
            id: 4,
            nome: <IntlMessage id = "dashboards.general.standardDoctorBill"/>,
            valor: result[0].faturarMedicoPadrao,
            key: 'sn_fatura_medico_padrao',
          },
        ],
        exe_padrao,
      });
    });
  }
  render() {
    return (
      <ConfigRecebimentoPage
        toggleSwitch={this.toggleSwitch.bind(this)}
        configs={this.state.configs}
        altura={this.props.altura}
        salvar={this.salvar.bind(this)}
        medicos={this.props.medicos}
        medicoExecutante={this.props.medicoExecutante}
        disabledSalvar={this.disabledSalvar.bind(this)}
        setMedicoExecutante={this.setMedicoExecutante.bind(this)}
      ></ConfigRecebimentoPage>
    );
  }

  disabledSalvar() {
    var disabled = false;
    if (this.state.configs.length > 0) {
      // Regra 1: se ativar o recurso de faturar somente com medico executante padrão o mesmo precisa ser informado
      var faturarMedicoPadrao = this.state.configs.find(
        (conf) => conf.id === 4
      );
      if (faturarMedicoPadrao.valor && !this.props.medicoExecutante) {
        disabled = true;
      }
    } else {
      disabled = true;
    }

    return disabled;
  }

  setMedicoExecutante(id) {
    this.props.actions.alterarMedicoExecutante(id);
    this.setState({
      exe_padrao: id.value,
    });
    if (!this.state.teveAlteracao) this.setState({ teveAlteracao: true });
  }

  toggleSwitch(id, valor) {
    let draft = [...this.state.configs];

    draft.map((conf) => {
      if (conf.id === id) {
        conf.valor = valor;
      }
      return conf;
    });
    this.setState({
      configs: draft,
    });

    if (!this.state.teveAlteracao) this.setState({ teveAlteracao: true });
  }

  salvar() {
    if (this.state.teveAlteracao) {
      var configBody = {};
      this.state.configs.map((conf) => {
        configBody = {
          ...configBody,
          ...{ [conf.key]: conf.valor ? 'S' : 'N' },
        };
        return conf;
      });

      // configurações filhas

      configBody = {
        ...configBody,
        ...{
          exe_padrao: this.state.exe_padrao,
        },
      };

      ConfiguracaoApi.gravarConfigRecebimento({ ...configBody })
        .then((result) => {
          this.props.commonActions.showAlerta(
            'sucesso',
            'Configuração salva com sucesso!',
            2500
          );
          this.setState({ teveAlteracao: false });
        })
        .catch((err) =>
          this.props.commonActions.showAlerta(
            'erro',
            'Não foi possivel salvar',
            2500
          )
        );
    } else {
      this.props.commonActions.showAlerta(
        'sucesso',
        'Configuração salva com sucesso!',
        2500
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {    
    medicos: state.commonReducer.medicos,
    medicoExecutante: state.configMaterial.medicoExecutante,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfigRecebimentoContainer);



// WEBPACK FOOTER //
// ./src/pages/configuracao/tab/material/recebimento.container.js